import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-dashboard-charts-selector',
    templateUrl: './dashboard-charts-selector.component.html',
    styleUrls: ['./dashboard-charts-selector.component.scss']
})
export class DashboardChartsSelectorComponent implements OnInit, OnChanges {

    @Input()
    metrics: Array<{name: string, total: number}> = [];
    @Output()
    selected: EventEmitter<string>;

    activeMetric: string;

    constructor() {
        this.selected = new EventEmitter();
    }

    ngOnInit() {

    }


    ngOnChanges(changes: SimpleChanges): void {
        if(changes.metrics && changes.metrics.currentValue && !changes.metrics.previousValue) {
            this.activeMetric = changes.metrics.currentValue[0].name;
        }
    }

    chooseMetric(metric){
        this.activeMetric = metric;
        this.selected.emit(metric);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard-charts-selector/dashboard-charts-selector.component.ts